import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../lib/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ao_lang") || "en");

  useEffect(() => {
    const dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
    document.body.dir = dir;
    localStorage.setItem("ao_lang", lang);
  }, [lang]);

  const t = (path) => {
    const parts = path.split(".");
    let v = translations[lang];
    for (const p of parts) v = v?.[p];
    return v ?? path;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t, dir: lang === "ar" ? "rtl" : "ltr" }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
